import { render, staticRenderFns } from "./SchoolInboxConfiguration.vue?vue&type=template&id=39dbbbb5&scoped=true&"
import script from "./SchoolInboxConfiguration.vue?vue&type=script&lang=js&"
export * from "./SchoolInboxConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInboxConfiguration.vue?vue&type=style&index=0&id=39dbbbb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dbbbb5",
  null
  
)

export default component.exports